import { LoteInfoRender, LoteInfoRow } from "./LoteInfoRender";

/** Ficha de lote para fincas de agricultura: agrega el cultivo. */
export class LoteInfoAgriculturaRender extends LoteInfoRender {
  protected getExtraRows(): LoteInfoRow[] {
    return [{ label: "Cultivo", value: this._lote.cultivo?.nombre ?? "—" }];
  }
}
